import { t } from '@lingui/core/macro';
import { MAP_PIN_RESTRICTION_RADIUS_M, MapPinSelectionDialog as SharedMapPinSelectionDialog } from 'noddi-web';

type Props = {
  initialLatitude?: number;
  initialLongitude?: number;
  addressLatitude?: number;
  addressLongitude?: number;
  onLocationSelected: (latitude: number, longitude: number) => void | Promise<void>;
  isOpen?: boolean;
  onClose?: () => void;
  isLoading?: boolean;
};

export const MapPinSelectionDialog = ({
  initialLatitude,
  initialLongitude,
  addressLatitude,
  addressLongitude,
  onLocationSelected,
  isOpen = false,
  onClose,
  isLoading = false
}: Props) => {
  const radiusMeters = MAP_PIN_RESTRICTION_RADIUS_M;

  return (
    <SharedMapPinSelectionDialog
      isOpen={isOpen}
      onClose={onClose}
      isLoading={isLoading}
      initialLatitude={initialLatitude}
      initialLongitude={initialLongitude}
      addressLatitude={addressLatitude}
      addressLongitude={addressLongitude}
      onLocationSelected={onLocationSelected}
      title={t`Select exact location where the car(s) will be parked`}
      pickupLabel={t`Car location`}
      addressLabel={t`Address`}
      confirmLabel={t`Confirm`}
      cancelLabel={t`Cancel`}
      centerPickupTitle={t`Center map on pin`}
      centerAddressTitle={t`Center map on address`}
      allowedAreaLabel={t`Allowed area (${radiusMeters} m)`}
    />
  );
};
